import { render } from "./SegmentDropdown.vue?vue&type=template&id=2e14389b&scoped=true"
import script from "./SegmentDropdown.vue?vue&type=script&lang=ts"
export * from "./SegmentDropdown.vue?vue&type=script&lang=ts"

import "./SegmentDropdown.vue?vue&type=style&index=0&id=2e14389b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e14389b"

export default script